import React from 'react';
import _ from 'lodash';
import {
    Datagrid,
    TextField,
    ReferenceManyField,
    ChipField,
    DateField,
    FunctionField,
} from 'react-admin';

import StorageLocation from '../../storages/components/StorageLocation';
import StorageTypeField from '../../components/StorageTypeField';
import DamageField from '../../components/DamageField';
import NameField from './NameField';

const getStorageCode = item => item?.storage?.code || '';

const compareByStorageCode = (a, b) => {
    const codeA = getStorageCode(a);
    const codeB = getStorageCode(b);

    if (codeA < codeB) return -1;
    if (codeB < codeA) return 1;
    return 0;
};

const TypeField = props =>
    props.record?.storage ? (
        <StorageTypeField record={props.record.storage} link={false} />
    ) : null;

const LocationField = props =>
    props.record?.storage ? (
        <StorageLocation record={props.record.storage} />
    ) : null;

const StorageList = props => {
    const ids = props.ids || [];
    const data = props.data ? _.values(_.pick(props.data, ids)) : [];
    const rowsWithStorage = data.filter(i => i?.storage);

    const parts = _.groupBy(
        rowsWithStorage.filter(i => i.storage.isPart),
        'parentId'
    );
    const lines = rowsWithStorage
        .filter(i => !i.storage.isPart)
        .sort(compareByStorageCode);
    const orphanParts = _.flatten(
        _.values(
            _.omit(
                parts,
                lines.map(i => i.id)
            )
        )
    );
    lines.push(...orphanParts);

    const tableRows: any[] = [];

    lines.forEach((line, i) => {
        const index = parts[line.id] ? `${i + 1}.1` : `${i + 1}`;

        tableRows.push({
            ...line,
            index,
        });

        if (parts[line.id]) {
            parts[line.id].sort(compareByStorageCode).forEach((part, j) => {
                tableRows.push({
                    ...part,
                    index: `${i + 1}.${j + 2}`,
                });
            });
        }
    });

    const tableIds: number[] = tableRows.map(i => i.id);
    const tableData: any = tableRows.reduce(
        (obj, i) => ({ ...obj, [i.id]: i }),
        {}
    );

    return (
        <Datagrid ids={tableIds} data={tableData}>
            <TextField source="serial" sortable={false} />
            <TextField source="index" label="No" />
            <TextField source="storage.code" label="Code" />
            <TypeField label="Type" />
            <DamageField source="storage.damage" label="Damage" />
            <NameField label="Name" />
            <TextField source="storage.size" label="CBM" />
            <ChipField source="storage.status" label="Status" />
            <DateField locales="en-IN" source="storage.from" label="From" />
            <DateField locales="en-IN" source="storage.to" label="To" />
            <LocationField label="Loc" />
            <FunctionField
                label=""
                render={record =>
                    record?.storage?.id ? (
                        <a href={`#/storages/${record.storage.id}/show`}>
                            Show
                        </a>
                    ) : null
                }
            />
        </Datagrid>
    );
};

const RequestStorageList = ({ record, ...props }: { record?: any }) => {
    return record ? (
        <ReferenceManyField
            {...props}
            filter={{ requestId: record.id }}
            sort={{ field: 'createdAt', order: 'DESC' }}
            reference="request-lines"
            target="requestId"
            perPage={1000}
        >
            <StorageList orderId={record.orderId} />
        </ReferenceManyField>
    ) : null;
};

export default RequestStorageList;
